import { type FeatureLike } from 'ol/Feature';
import { Fill, Stroke, Style, Text } from 'ol/style';
import { createDefaultStyle } from 'ol/style/Style';
import { type IMapWidget } from '../IMapWidget.ts';

const WEB_MERCATOR_RESOLUTION_AT_ZOOM_0 = 156_543.03;

function resolutionToZoom(resolution: number) {
  return Math.log2(WEB_MERCATOR_RESOLUTION_AT_ZOOM_0 / resolution);
}

/**
 * Style function per le geometrie disegnate dall'utente.
 * Usa lo stile default di OL come base e sovrappone la label "# N"
 * quando il geometryIndex è presente e lo zoom è nel range configurato.
 */
export function createGeometryLabelStyle(widget: IMapWidget) {
  const { labeling } = widget;

  return (feature: FeatureLike, resolution: number) => {
    const baseStyles = createDefaultStyle(feature, resolution);

    if (labeling?.enabled === false) return baseStyles;

    const geometryIndex = feature.get('geometryIndex') as number | undefined;
    if (geometryIndex == null) return baseStyles;

    const zoom = resolutionToZoom(resolution);
    if (
      zoom < (labeling?.zoomRange?.min ?? 0) ||
      zoom > (labeling?.zoomRange?.max ?? 22)
    ) {
      return baseStyles;
    }

    return [
      ...baseStyles,
      new Style({
        text: new Text({
          text: `${labeling?.prefix ?? '#'} ${geometryIndex}`,
          fill: new Fill({ color: '#fff' }),
          stroke: new Stroke({ color: '#333', width: 3 }),
          font: 'bold 13px sans-serif',
          overflow: true,
        }),
      }),
    ];
  };
}
